import { Address, PoolId } from 'src/admin/core/models'

export interface BaseEntity {
  id: string
  name: string
  active?: boolean
}

export interface Device extends BaseEntity {}
export interface Agency extends BaseEntity {
  products?: Products[]
}

export enum WorkstationProductsEnum {
  HORSE_RACES = 'HORSE_RACES',
  COCKFIGHTS = 'COCKFIGHTS',
  SPORTS = 'SPORTS',
  LOTTERY_TICKET = 'LOTTERY_TICKET',
}

export interface Enterprise extends BaseEntity {
  domain: string
  subdomain: string
  products?: WorkstationProductsEnum[]
  addresses?: Address[]
}

export type WorkstationType = 'NONE' | 'TERMINAL' | 'MOBILE' | 'KIOSK'

export type Workstation = {
  id: string
  name: string
  type: WorkstationType
  active: boolean
  enterprise: Enterprise
  agency: Agency
  device: Device
  accessList?: string[]
}

export type Payoff = {
  net: number
}

export interface Entry {
  [key: string]: string | number | boolean
  id: string
  entryId: string
  name: string
  jockey: string
  weight: string
  trainer: string
  owner: string
  position: number
  medication: string
  scratch: boolean
}

export interface Runner {
  runnerId: number
  entries: Entry[]
  odds: string
  scratch: boolean
}

export type WagerPayoff = {
  ticketId: string
  claimed: boolean
  payoff: Payoff
}

export interface WagerLeg {
  raceId: number
  runners: Runner[]
}

export type Wager = {
  id: string
  legs: WagerLeg[]
  poolId: PoolId
  total: number
}

export type League = {
  sport: string
  name: string
}

export type Event = {
  league: League
  eventStatus: 'Open' | 'Closed' | 'Final'
}

export type HorseRacesWager = {
  eventId: string
  wagerPayoff: WagerPayoff
  wagers: Wager[]
  providerTicketId: string
  event: Event
  displayValue: string
  race: number
  postTime: Date
}

export type CockfightsWager = {
  eventId: string
  wagerPayoff: WagerPayoff
}

export type Products = {
  code: string
}

export enum GeographicTypeEnum {
  Unknown = -1,
  Point = 'POINT',
  MultiPoint = 'MultiPoint',
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  Polygon = 'Polygon',
  MultiPolygon = 'MultiPolygon',
  GeometryCollection = 'GeometryCollection',
}

export type Geographic = {
  type: GeographicTypeEnum
  coordinates: number[]
  latitude?: number
  longitude?: number
}
